<template>
	<div>
		<v-card elevation="0" :style="'background-color:' + $theme.lightBlue">
			<v-card-title style="font-size: large">
				앱 버전 관리
			</v-card-title>
			<v-form ref="form" v-model="formValid">
				<v-container fluid>
					<v-row>
						<v-col>
							<v-card-title style="font-size: medium">
								AOS 버전
							</v-card-title>
							<v-text-field v-model="item.aosAllowMinmumBuildNumber" :rules="$rules.inputRules" label="AOS 최소 빌드 번호" required outlined> </v-text-field>
							<v-text-field v-model="item.aosLastestVersion" :rules="$rules.inputRules" label="AOS 마지막 버전" required outlined> </v-text-field>
						</v-col>
						<v-col>
							<v-card-title style="font-size: medium">
								IOS 버전
							</v-card-title>
							<v-text-field v-model="item.iosAllowMinmumBuildNumber" :rules="$rules.inputRules" label="IOS 최소 빌드 번호" required outlined> </v-text-field>
							<v-text-field v-model="item.iosLastestVersion" :rules="$rules.inputRules" label="IOS 마지막 버전" required outlined> </v-text-field>
						</v-col>
					</v-row>
					<v-btn rounded :color="$theme.primary" dark elevation="0" class="ma-6" @click="saveMessageDialog = true">
						버전 변경
					</v-btn>
				</v-container>
			</v-form>
		</v-card>

		<MessageDialog
			:show="saveMessageDialog"
			message="저장하시겠습니까?"
			:okButton="true"
			okButtonText="저장"
			:cancelButton="true"
			cancelButtonText="취소"
			@onOk="modifyItem"
			@onCancel="saveMessageDialog = false"
		/>
	</div>
</template>

<script>
	export default {
		name: 'AppVersionForm',
		props: {
			item: {
				default: {},
			},
		},
		data: () => ({
			formValid: false,
			saveMessageDialog: false,
		}),
		mounted: function() {},
		methods: {
			modifyItem() {
				this.$refs.form.validate();
				if (this.formValid) {
					this.$emit('modifyItem', this.item);
				}
			},
		},
	};
</script>

<style scoped>
	.bg-lb {
		background-color: #f2f5ff;
	}
</style>
